export enum SupportCenterMetricsEvent {
    OnCreateTicketLinkClick = 'onCreateTicketLinkClick',
    OnShipmentReferenceComplete = 'onShipmentReferenceComplete',
    OnSupportTicketCategorySelection = 'onSupportTicketCategorySelection',
    OnSupportTicketCreation = 'onSupportTicketCreation',
    OnSupportTicketDetailsClick = 'onSupportTicketDetailsClick',
}
